"use client";

import { useState } from "react";
import Image, { ImageProps } from "next/image";

type Props = {
  isActivity?: boolean
  type?: "Meal" | "Sightseeing" | "Shopping" | "Nature";
} & ImageProps

export default function ImageLoading({ isActivity = false, type, ...props }: Props,) {
  const [loadFailed, setLoadFailed] = useState(false);
  const processFilename = (filename: string) => filename?.replace(/\.[^/.]+$/, "")?.endsWith("planingo") ?
    `${process.env.NEXT_PUBLIC_STORAGE_URL}${filename}` : filename;
  const fileName = processFilename(props.src as string)

  return (
    <div className={`${props.className} relative  h-full w-full `}>
      {!loadFailed && fileName && (
        <Image
          {...props}
          src={fileName}
          loading={props.priority ? "eager" : "lazy"}
          onError={() => {
            setLoadFailed(true)
          }}
          className={`${props.className} object-cover transition-opacity duration-200 ${loadFailed ? "hidden" : props.priority ? '' : "opacity-0"
            }`}
          onLoad={(e) => e.currentTarget.classList.remove("opacity-0")}
        />
      )}
      {/* Show Fallback Image if Load Fails */}
      {(loadFailed || !fileName) && (
        <div style={props.style} className={`${props.className}  flex h-full w-full items-center justify-center bg-gray-200 text-gray-400 `}>
          <Image className='w-1/2 max-w-36' width={200} height={200} alt="Planingo"
            src={`${process.env.NEXT_PUBLIC_STORAGE_URL}${!isActivity ?
              'assets/7a936346-7269-40c4-96f7-1eb81260c279-planingo.png' :
              type === "Meal" ? 'assets/7d967fff-6dba-4aa7-bd44-5a92e33a2885-planingo.png' :
                type === "Shopping" ? 'assets/4729fecd-1855-40ba-b8cb-fc182d677e64-planingo.png' :
                  type === "Nature" ? 'assets/cf153318-90ab-4e35-bb9b-d0382d8dfa52-planingo.png' :
                    type === "Sightseeing" ? 'assets/d4a50fc0-3b58-4aaa-bd17-c45e86cb79eb-planingo.png' :
                      `assets/dca5d3b1-dbe2-4899-8f97-1e77a874000b-planingo.png`}`} />
        </div>
      )}
    </div>
  );
}
